export function Overline({ children, className = "" }) {
  return <div className={`overline ${className}`} data-testid="overline">{children}</div>;
}

export function SectionHeading({ overline, title, body, align = "left", className = "" }) {
  return (
    <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-2xl ${className}`}>
      {overline && <Overline className="mb-5">{overline}</Overline>}
      <h2 className="h-serif text-4xl md:text-5xl text-white font-semibold">{title}</h2>
      {body && <p className="mt-6 text-zinc-400 text-lg leading-relaxed">{body}</p>}
    </div>
  );
}
